import {
  anEntityPage,
  anInsightPage,
  aSearchResultPage,
  aSignalPage,
  mockKeywordSearchQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockKeywordSearchQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          dslSearchResults: aSearchResultPage(),
          entities: anEntityPage(),
          insights: anInsightPage(),
          signals: aSignalPage(),
        },
      });
    }
  ),
];
